export default "__VITE_ASSET__8T$jrmDX__"